export const style = {
  title: {
    fontSize: 'lg',
    fontWeight: 'bold',
    textAlign: 'center',
    paddingX: 10,
    paddingTop: 5,
  },
  listItem: {
    fontSize: 'md',
    textAlign: 'left',
  },
  button: {
    w: 'full',
    whiteSpace: 'break-spaces',
    textAlign: 'center',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingY: 5,
    rowGap: 5,
  },
  box: {
    boxSize: '100',
  },
  image: {
    width: '100%',
    height: '100%',
  },
};
